import { render } from "./AppInputDate.vue?vue&type=template&id=47722854&scoped=true&ts=true"
import script from "./AppInputDate.vue?vue&type=script&lang=ts"
export * from "./AppInputDate.vue?vue&type=script&lang=ts"

import "./AppInputDate.vue?vue&type=style&index=0&id=47722854&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47722854"]])

export default __exports__